<template>
  <!-- 页面筛选条件区域  -->
	<div class="filter" :class="{'hideMoreBtStyle': isHideMoreBt}"> 
    <div class="content" :class="{showMoreStyle: isShowMore}">
      <slot></slot>
    </div> 
    <div class="showMoreArea" v-if="!isHideMoreBt">
      <div @click="toggleIsShowMore">
        {{isShowMore ? "收起" : "展开"}}<span class="more el-icon-d-arrow-left"  :class="{showMoreArrowStyle: isShowMore}"></span>
      </div>
    </div>
    <div class="btArea">
      <span class="bt" v-for="item in showBtLists" :key="item.name" @click="$emit(item.click)" :loading=" item.name == '导出'">
        <i class="el-icon-loading" v-if="item.name == '导出' && isLoading"></i>
        {{item.name}}
      </span> 
    </div>
  </div>
</template>
<script>
export default {
  props: ['bts', 'isHideMoreBt', 'isLoading', 'roleBt'],
  data() {
    return {
      isShowMore: false,
      btListsObj:{ 
        addBt:{
          name:"新增",
          click:"add",
        },
        exportBt:{
          name:"导出",
          click:"exportBt",
        },
        importBt:{
          name:"导入",
          click:"import",
        },
        searchBt:{
          name:"查询",
          click:"search",
        },
        printBt:{
          name:"打印",
          click:"printBt",
        },
        columnBt:{
          name:"列控制",
          click:"columnBt",
        },
      },
      showBtLists:[],
      loadRoleBtNum: 0,
      loadRoleBtTimer: null,
    };
  },
  created(){
    this.initBts();
  },
  computed: { 
  },
  watch: { 
    roleBt:{
      handler(newValue, oldValue) {
        this.initBts();
      },
      deep: true
    },
    bts:{
      handler(newValue, oldValue) {
        this.initBts();
      },
      deep: true
    }
  },
  methods: { 
    initBts(){
      this.showBtLists = [];
      // 筛选区按钮权限配置
      if(this.bts && this.bts.length) { 
          this.bts.forEach((item)=>{ 
            this.showBtLists.push(this.btListsObj[item]);
          })
      } else {
        this.showBtLists = JSON.parse(JSON.stringify(this.btListsObj))
      }
    },
    toggleIsShowMore(){
      this.isShowMore = !this.isShowMore;
      this.$emit('isShowMore', this.isShowMore);
    },
  },
  components: {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less">
@import "@/assets/stylesheets/config.less";
.filter {
  width: 100%;
  min-height: 46px;
  padding:10px;
  background:#fff;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  // display: flex;
  align-items: flex-start; 
  .content {
    height: 47px;
    overflow: hidden;
  }
  .showMoreStyle {
    height: auto;
    overflow: auto;
    padding-bottom: 10px;
  }
  
  .btArea {
    display: flex;
    justify-content: flex-end;
    .bt {
      margin: 0 6px;
      height: 26px;
      line-height: 26px;

      // border: 1px solid #3078ff;
      // background: #fff;
      // color: #3078ff;
      &:hover {
        background: #3078ff;
        color: #fff;
      }
    }
  }
  .showMoreArea {
    display: flex;
    position:absolute;
    bottom: 0;
    height: 38px;
    // justify-content: center;
    align-items: center;
    width: 37vw;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    background: #fff;
    &:hover {
      color: #333;
    }
    div {
      position: absolute;
      left: 90%;
      width: 50px;
      .more { 
        transform: rotate(-90deg)
      }
      .showMoreArrowStyle {
        transform: rotate(90deg)
      }
    }
    .totalNum {
      position: absolute;
      left: 15px;
    }
    
  }
}
.hideMoreBtStyle {
  .content {
    height: auto;
    padding-right: 240px;
    overflow: auto !important;
  }
  .btArea {
    position: absolute;
    right: 10px;
    top: 17px;
  }
}
</style>